export const event_available = ["Standard", "Black"];
